var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"main",attrs:{"data-title":"活动展示"}},[_c('div',{staticClass:"content"},[_c('AllHeader',{attrs:{"title":"活动展示"}}),_c('NewsList',{attrs:{"fenlei":"活动展示"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }